<script lang="ts">
	import type { StatusOption, SearchField, Status, SearchFieldProps } from 'utility/search-fields'
	import type { SvelteSet } from 'svelte/reactivity'

	import Select from '@isoftdata/svelte-select'
	import EditModeControls from './EditModeControls.svelte'
	import Pin from './Pin.svelte'
	import { createEventDispatcher, type ComponentProps } from 'svelte'
	import { getEventValue } from '@isoftdata/browser-event'

	interface Props
		extends Omit<ComponentProps<typeof Select<Status | null>>, 'options' | 'value' | 'emptyText'>,
			SearchFieldProps<Status | null> {
		status?: Status | '@' | null
	}

	let {
		searchField,
		inEditMode,
		pinnedSearchFields = $bindable(),
		selectedSearchFieldsKeys = $bindable(),
		status = $bindable('@'),
		disabled = false,
		change: changeCb,
		...rest
	}: Props = $props()

	let statusList: StatusOption[] = [
		{ abbrev: '@', description: 'Status A or H' },
		{ abbrev: 'A', description: 'Available' },
		{ abbrev: 'H', description: 'On Hold' },
		{ abbrev: 'S', description: 'Sold' },
		{ abbrev: 'C', description: 'Crushed' },
		{ abbrev: 'D', description: 'Deleted' },
		{ abbrev: 'T', description: 'Transferred' },
		{ abbrev: 'B', description: 'Bidding' },
	]

	function isStatusAbbreviation(string: string): string is StatusOption['abbrev'] {
		return !!statusList.find(status => status.abbrev === string)
	}

	function change(e: Event) {
		const status = getEventValue(e)
		if (isStatusAbbreviation(status)) {
			changeCb?.({ field: searchField, value: status })
		}
	}
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<Select
		{...rest}
		label="Status"
		emptyText="Any Status"
		disabled={disabled || inEditMode}
		bind:value={status}
		onchange={change}
	>
		{#snippet hint()}
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		{/snippet}

		{#each statusList as status}
			<option value={status?.abbrev ?? null}>{status?.abbrev} - {status?.description}</option>
		{/each}
	</Select>
</EditModeControls>
